import format from 'date-fns/format'

export default function (value, dateFormat) {
  if (!value) return ''

  if (!(value instanceof Date)) value = Date.parse(value)

  return format(value, dateFormat || 'dd-MM-yyyy')
}



// WEBPACK FOOTER //
// ./src/plugins/filters/date.js